// import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Styles from "./ListQus.module.css";
import { API_BASE_URL } from "../constants/apiConfig";

const ListQus = () => {
  const [qus, setQus] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  
  useEffect(() => {
    // fetch("http://localhost:8001/admin/qp", { credentials: "include" })
    fetch(`${API_BASE_URL}/admin/qp?page=${page}`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data: any) => {
        setQus(data.questions || []);
        setTotalCount(data.totalCount || 0);
      });
  }, [page]);
  return (
    <>
      <h2>List All Questions</h2>
            <div className={Styles.paginationContainer}>
        <label htmlFor="pageSelect">Select Page:</label>
        <select 
          id="pageSelect"
          value={page} 
          onChange={(e) => setPage(Number(e.target.value))}
          className={Styles.pageDropdown}
        >
          {Array.from({ length: Math.ceil(totalCount / 10) }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              Page {i + 1}
            </option>
          ))}
        </select>
        <span className={Styles.pageInfo}>Total Questions: {totalCount}</span>
      </div>

      {qus.length &&
        qus.map((q: any, index) => (
          <div className={Styles.qusHome}>
            <div className={Styles.fullQus}>
              <div className={Styles.qusIndex}>
                {index < 10 ? "0" + (index + 1) : index + 1}
              </div>
              <div className={Styles.perQus}>{q.question}</div>
            </div>
            <div className={Styles.optionsContainer}>
              <div className={Styles.optionsGrid}>
                <div className={Styles.optionItem}>
                  {q.answer === 1 && <span className={Styles.greenTick}>✓</span>}
                  <span className={Styles.optionLabel}>A.</span>
                  <span className={Styles.optionText}>{q.optionA}</span>

                </div>
                <div className={Styles.optionItem}>
                  {q.answer === 2 && <span className={Styles.greenTick}>✓</span>}
                  <span className={Styles.optionLabel}>B.</span>
                  <span className={Styles.optionText}>{q.optionB}</span>

                </div>
                <div className={Styles.optionItem}>
                  {q.answer === 3 && <span className={Styles.greenTick}>✓</span>}
                  <span className={Styles.optionLabel}>C.</span>
                  <span className={Styles.optionText}>{q.optionC}</span>

                </div>
                <div className={Styles.optionItem}>
                  {q.answer === 4 && <span className={Styles.greenTick}>✓</span>}
                  <span className={Styles.optionLabel}>D.</span>
                  <span className={Styles.optionText}>{q.optionD}</span>

                </div>
              </div>
            </div>
            <div className="flex gap-2 mt-4">
              <Link to={`/editqus/${q.unique_id}`} className="btn btn-sm btn-outline btn-primary">
                Edit
              </Link>
            </div>
          </div>
        ))}
    </>
  );
};

export default ListQus;
